import { AxiosInstance } from "axios"
import { DeviceSupportAdmin } from "./adminDevicesTypes"

type AllDevicesParams = Readonly<{}>

export type DevicesSupportAdminResponse = Readonly<{
    devices: DeviceSupportAdmin[]
}>

export async function fetchAllDevices(
    {}: AllDevicesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DevicesSupportAdminResponse> {
    const { data } = await axios.get(`/devices`, {
        signal,
    })
    return data
}
